<template>
    <div class="list scrollBar_xy" :id="config.domId">
        <div class="info_list scrollBar_xy">
            <div class="info_title " :style="{
                    color:config.titleStyle.font.color,
                    fontSize:config.titleStyle.font.fontSize+'px',
                    borderColor:config.titleStyle.borderColor,
                    borderStyle:config.titleStyle.borderStyle,
                    borderBottomWidth:config.titleStyle.borderWidth+'px',
                    width:trans.width+'px',
                    height:config.titleStyle.height+'px',
                    lineHeight:config.titleStyle.height+'px',
                    backgroundSize:'100% 100%',
                    backgroundColor:config.titleStyle.background.type === 'color'?config.titleStyle.background.color:'rgba(255,255,255,0)',
                    backgroundImage:config.titleStyle.background.type === 'picture'?`url('${config.titleStyle.background.picture}')`:`url('${config.titleStyle.background.border}')`,
                }">
                    <span v-for="(item,index) in dlWidthList" :style="{
                        color:config.titleStyle.font.color,
                        fontSize:config.titleStyle.font.fontSize+'px',
                        fontWeight:config.titleStyle.font.fontWeight,
                        fontFamily:config.titleStyle.font.fontFamily,
                        width:item.verticalWidth + '%',
                        textAlign:config.titleStyle.align,
                    }">{{item.name}}</span>
            </div>
            <div class="info_body"
                 :style="{
                        width:trans.width+'px',
                        height:`calc(100% - ${config.titleStyle.height}px)`,
                        overflow:config.scrllOrswiper === 'scroll'?config.scrllOrswiper:'hidden'
                 }">
                <div v-for="(item,index) in dataList" :style="{
                        borderColor:config.bodyStyle.borderColor,
                        borderStyle:config.bodyStyle.borderType,
                        borderBottomWidth:config.bodyStyle.borderWidth+'px',
                        height:config.bodyStyle.height+'px',
                        lineHeight:config.bodyStyle.height+'px',
                        width:trans.width+'px',
                        backgroundSize:'100% 100%',
                        backgroundColor:config.bodyStyle.background.type === 'color'?item.color:'rgba(255,255,255,0)',
                        backgroundImage:config.bodyStyle.background.type === 'picture'?`url('${config.bodyStyle.background.picture}')`:`url('${config.bodyStyle.background.border}')`,
                        margin:`${config.bodyStyle.margin.top}px 0 ${config.bodyStyle.margin.bottom}px 0`
                    }">
                        <span v-for="(val,idx) in dlWidthList" :style="{
                             color:config.bodyStyle.font.color,
                             fontSize:config.bodyStyle.font.fontSize+'px',
                             fontWeight:config.bodyStyle.font.fontWeight,
                             fontFamily:config.bodyStyle.font.fontFamily,
                             width:val.verticalWidth + '%',
                             textAlign:config.bodyStyle.align,
                        }">{{item[val.name]}}</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    /**
     @author
     @date 2020/5/17 4:58 下午
     */
    export default {
        name: 'itemList',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            option: {
                type: Object,
                default: () => {

                }
            },
            trans: {
                type: Object,
                default: function () {
                    return {width: '100%'}
                }
            },
        },
        data() {
            return {
                timer: null,
                value: 0,
            }
        },
        computed: {
            config(a) {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
            dlWidthList() {
                try {
                    let dlList = [];
                    let list = [];
                    let width = 0;
                    if (this.type === 'view') {
                        dlList = this.$store.state.viewDP.chart.setting.dlList;
                    }else if (this.type === 'screen') {
                        dlList = this.option.setting.dlList;
                    }
                    dlList.map((value, index, array) => {
                        width += parseInt(value.params.verticalWidth);
                        this.config.nameList.map((v, i) => {
                            if (value.name === v) {
                                list.push({
                                    name: value.name,
                                    verticalWidth: parseInt(value.params.verticalWidth),
                                    maxNum: parseInt(value.params.maxNum)
                                })
                            }
                        })
                    });
                    list.unshift({
                        name: this.config.nameList[0],
                        verticalWidth: 100 - width,
                        maxNum: 100
                    })
                    list.map((value, index, array)=>{
                        value.maxNum = parseInt(100 - width + value.verticalWidth)
                    })
                    if (100 - width < 0) {
                        list.map((v,i) => {
                            v.verticalWidth =  parseInt(100 / list.length);
                            v.maxNum =  parseInt(100 / list.length *2)
                        })
                    }
                    dlList.map((value, index, array)=>{
                        value.params.verticalWidth = parseInt(list[index + 1].verticalWidth);
                        value.params.maxNum = parseInt(list[index + 1].maxNum)
                    });
                    return list
                }catch (e) {

                }

            },
            dataList(){
                let a = [];
                this.config.dataList.map((value, index, array)=>{
                    a.push(value);
                })
                if(this.config.bodyStyle.background.colorGroup[0] === undefined){
                    a.map((value, index, array)=>{
                        value.color = 'rgba(255,255,255,0)'
                    })
                }else {
                    let colorGrNnm = this.config.bodyStyle.background.colorGroup.length;
                    let num = Math.ceil(a.length / colorGrNnm);
                    let remainder = Math.round(a.length%colorGrNnm);
                    let c = 0;
                    let arr = [];
                    for(let s = 0;s<num;s++){
                        this.config.bodyStyle.background.colorGroup.map((value, index, array)=>{
                            arr.push(Object.assign({},a[c],{color:value}))
                            c++;
                        })
                    }
                    arr.length = this.config.dataList.length;
                    a = arr;
                }
                return a
            }
        },
        watch: {
            // 'option.setting.dlList'(newDate, oldDate) {
            //     if (newDate.length !== oldDate.length) {
            //         this.dlWidthList.map((v) => {
            //             v.verticalWidth = 100 / this.dlWidthList.length;
            //             v.maxNum = 100 / this.dlWidthList.length;
            //         })
            //     }
            // },
        },
        methods: {
            get() {
                // if(this.config.scrllOrswiper == 'swiper' ){
                //     let time = Number(this.config.time);
                //     let height = this.config.bodyStyle.height;
                //     log(time,'开始了')
                //     clearInterval(this.timer);
                //     this.timer = null;
                //     this.timer = setInterval(function(){
                //         '重复开始了s');
                //         $('.info_body').find('div').eq(0).animate({
                //             height:0,
                //         },function(){
                //             $(this).appendTo($('.info_body')).height(height);
                //         })
                //     },time);
                // }else{
                //     clearInterval(this.timer);
                //     this.timer = null;
                // }
            },
        },
        mounted() {
            // this.get();
            // this.timer = setInterval(this.get, 1000);
        },
        beforeDestroy() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .list {
        text-align: center;

        &.scrollBar_xy {
            ::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
        }

        .info_list {
            /*padding: 0 20px;*/
            height: 100%;
            /*margin-top: 20px;*/
            overflow-x: auto;

            &.scrollBar_xy {
                ::-webkit-scrollbar {
                    width: 6px;
                    height: 0px;
                }
            }

            > div {
                span {
                    color: #aeaeae;
                    font-size: 14px;
                    display: inline-block;
                    vertical-align: middle;
                    width: 50px;
                    text-align: center;

                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;

                    &.el-icon-info, &.el-icon-success {
                        font-size: 22px;
                        color: #26ccdb;
                    }
                }

                &.info_title {
                    border-bottom: none;
                    height: 30px;
                    line-height: 30px;
                    white-space: nowrap;
                    text-align: left;

                    > span {
                        font-size: 16px;
                        color: #00a3e8;
                    }
                }

                &.info_body {
                    white-space: nowrap;
                    overflow: scroll;
                    text-align: left;

                    > div {
                        font-size: 14px;
                        border-bottom: solid 1px #e5e5e5;
                        line-height: 24px;
                        height: 30px;
                    }

                }
            }

            &.usey {
                > div {
                    span {
                        width: calc(100% / 5);
                    }
                }
            }
        }
    }
</style>
